"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".radio-buttons .bx--radio-button-group {\n  display: initial; }\n  .radio-buttons .bx--radio-button-group .bx--radio-button-wrapper .bx--radio-button__label {\n    justify-content: initial;\n    line-height: 18px; }\n    .radio-buttons .bx--radio-button-group .bx--radio-button-wrapper .bx--radio-button__label .bx--radio-button__appearance {\n      margin-bottom: 8px; }\n    .radio-buttons .bx--radio-button-group .bx--radio-button-wrapper .bx--radio-button__label span:nth-child(2) {\n      padding-top: 1px; }\n";
  const fileName = "RadioButtons_RadioButtons";
  const element = document.querySelector("style[data-sass-component='RadioButtons_RadioButtons']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const RadioButtons = props => {
  const radioButtons = props.items.map(item => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.RadioButton, {
      key: item.value,
      value: item.value,
      labelText: item.label
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'radio-buttons'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.RadioButtonGroup, {
    name: props.name,
    valueSelected: props.selectedValue,
    onChange: value => props.onChange(value)
  }, radioButtons));
};
RadioButtons.propTypes = {
  name: _propTypes.default.string.isRequired,
  items: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  selectedValue: _propTypes.default.string
};
var _default = exports.default = RadioButtons;